import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import { DateObject } from 'react-multi-date-picker';

export function createCustomContentId() {
  return `cc_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

/** اندیس پست سرور؛ مطلب custom بعد از همان پست رندر می‌شود (-1 = قبل از اولین پست). */
export function normalizeInsertAfterIndex(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : -1;
}

export function serializeCustomContentForm(formData, insertAfterIndex) {
  let datetimeIso = '';
  const dt = formData?.datetime;
  if (dt != null && dt !== '') {
    if (typeof dt.toDate === 'function') {
      datetimeIso = dt.toDate().toISOString();
    } else if (dt instanceof Date) {
      datetimeIso = dt.toISOString();
    } else {
      datetimeIso = new Date(dt).toISOString();
    }
  }

  return {
    id: createCustomContentId(),
    resourceTitle: String(formData?.resourceTitle ?? ''),
    title: String(formData?.title ?? ''),
    description: String(formData?.description ?? ''),
    content: String(formData?.content ?? ''),
    datetime: datetimeIso,
    insertAfterIndex: normalizeInsertAfterIndex(insertAfterIndex),
  };
}

export function normalizeStoredCustomContentItem(item) {
  if (!item?.id) return null;
  return {
    id: String(item.id),
    resourceTitle: String(item.resourceTitle ?? ''),
    title: String(item.title ?? ''),
    description: String(item.description ?? ''),
    content: String(item.content ?? ''),
    datetime: String(item.datetime ?? ''),
    insertAfterIndex: normalizeInsertAfterIndex(item.insertAfterIndex),
  };
}

export function normalizeCustomContents(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }
  const out = {};
  Object.keys(raw).forEach((platformKey) => {
    const list = raw[platformKey];
    if (!Array.isArray(list)) return;
    out[platformKey] = list
      .map(normalizeStoredCustomContentItem)
      .filter(Boolean);
  });
  return out;
}

export function cloneCustomContents(customContents) {
  const normalized = normalizeCustomContents(customContents);
  const out = {};
  Object.keys(normalized).forEach((platformKey) => {
    out[platformKey] = normalized[platformKey].map((item) => ({ ...item }));
  });
  return out;
}

export function draftHasCustomContents(draft) {
  const customContents = normalizeCustomContents(draft?.customContents);
  return Object.values(customContents).some((list) => list.length > 0);
}

export function getCustomContentsForPlatform(
  draft,
  platform,
  insertAfterIndex
) {
  if (!platform) return [];
  const customContents = normalizeCustomContents(draft?.customContents);
  const list = customContents[String(platform)] ?? [];
  if (insertAfterIndex === undefined) return list;
  const slot = normalizeInsertAfterIndex(insertAfterIndex);
  return list.filter(
    (item) => normalizeInsertAfterIndex(item.insertAfterIndex) === slot
  );
}

export function formatCustomContentDateTime(datetimeIso) {
  if (!datetimeIso) return '';
  try {
    return new DateObject(new Date(datetimeIso))
      .convert(gregorian, gregorian_en)
      .format('YYYY-MM-DD HH:mm:ss');
  } catch {
    return String(datetimeIso);
  }
}
